import { cloudFunction } from 'services/parse';

export const fetchPickPackList = (data: Record<string, any>) => {
  return cloudFunction('fetchPickPackList', data);
};

export const fetchPickPackListDetail = (id: string) => {
  return cloudFunction('fetchPickPackListDetail', { id });
};

export const togglePickPackListLock = (id: string) => {
  return cloudFunction('togglePickPackListLock', { id });
};

export const deletePickPackList = (id: string) => {
  return cloudFunction('deletePickPackList', { id });
};

export const generateFormattedDataForPickPackList = (id: string) => {
  return cloudFunction('generateFormattedDataForPickPackList', { id });
};

export const createPickPackList = (data: Record<string, any>) => {
  return cloudFunction('createPickPackList', data);
};

export const fetchOrderIdsInPickPackList = (id: string) => {
  return cloudFunction('fetchOrderIdsInPickPackList', { id });
};